import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { getSurveyLaunchId, productSurveyApi } from "@/lib/productSurvey";

/** Conta uma abertura autenticada por sessão de aba/WebView, mesmo antes do plano. */
export function useProductSurveyOpening(): void {
  const { session } = useAuth();
  const owner = session?.user.id;
  const token = session?.access_token;
  useEffect(() => {
    if (!owner || !token) return;
    const launchId = getSurveyLaunchId();
    if (!launchId) return;
    void productSurveyApi.opening(token, launchId, false).catch(() => {
      /* Pesquisa opcional: a falta de rede não bloqueia a abertura do app. */
    });
  }, [owner, token]);
}
